import menuStore from './localForageInstance';
import {
  getOfflineMenuCategories,
  getOfflineMenuProducts,
} from './androidOfflineMenu';

const isOfflineAndroid = () => {
  return (
    typeof window !== 'undefined' &&
    window.AndroidPOS &&
    typeof window.AndroidPOS.isAndroidPOS === 'function' &&
    window.AndroidPOS.isAndroidPOS() === true &&
    typeof window.AndroidPOS.isOfflineMode === 'function' &&
    window.AndroidPOS.isOfflineMode() === true
  );
};

const hydrateOfflineMenu = async () => {

  if (!isOfflineAndroid()) {
    return false;
  }

  console.log('[OFFLINE_MENU] Starting Room → localForage hydration');

  try {

    // =====================================================
    // 1. CATEGORIES
    // =====================================================

    const categoryResponse =
      await getOfflineMenuCategories();

    console.log(
      '[OFFLINE_MENU] Room category response:',
      categoryResponse
    );

    const categories =
      categoryResponse?.data;

    if (
      Array.isArray(categories) &&
      categories.length > 0
    ) {

      await menuStore.setItem(
        'dish_category_items',
        categories
      );

      console.log(
        '[OFFLINE_MENU] Categories hydrated:',
        categories.length
      );

    } else {

      console.warn(
        '[OFFLINE_MENU] No categories found in Room'
      );
    }


    // =====================================================
    // 2. PRODUCTS
    // =====================================================

    const productResponse =
      await getOfflineMenuProducts();

    console.log(
      '[OFFLINE_MENU] Room product response:',
      productResponse
    );

    const products =
      productResponse?.data || [];

    if (Array.isArray(products)) {

      for (const product of products) {

        if (!product) {
          continue;
        }

        const itemId =
          product.item_id ??
          product.product_id;

        if (
          itemId === undefined ||
          itemId === null ||
          String(itemId).trim() === ''
        ) {
          console.warn(
            '[OFFLINE_MENU] Product has no item_id:',
            product
          );
          continue;
        }

        const key =
          `product_${itemId}`;

        await menuStore.setItem(
          key,
          product
        );

        console.log(
          '[OFFLINE_MENU] Product hydrated:',
          key
        );
      }

      console.log(
        '[OFFLINE_MENU] Products hydrated:',
        products.length
      );
    }

    console.log(
      '[OFFLINE_MENU] Room - localForage hydration complete'
    );

    return true;

  } catch (error) {

    console.error(
      '[OFFLINE_MENU] Hydration failed:',
      error
    );

    return false;
  }
};

export default hydrateOfflineMenu;